/**
 * Returns URL for a currency flag SVG. Uses only existing files; falls back to USD if missing (e.g. DKK, NOK).
 */
const flagContext = require.context("../assets/flags", false, /\.svg$/);
const flagMap = {};
flagContext.keys().forEach((key) => {
  const name = key.replace(/^\.\/(.*)\.svg$/, "$1");
  const mod = flagContext(key);
  flagMap[name] = typeof mod === "string" ? mod : mod?.default ?? mod;
});

const defaultFlag = flagMap.USD;

export function getFlagUrl(symbol) {
  if (!symbol) return defaultFlag;
  return flagMap[symbol] ?? defaultFlag;
}
